import React from "react";
import { FiExternalLink } from "react-icons/fi";

const Our_Plan = () => {
    return (
        <section className="py-5 position-relative"
            style={{
                overflow: 'hidden'
            }}
        >
            <div
                className="px-4 mx-auto position-relative"
                style={{
                    maxWidth: '74%',
                    zIndex: 1
                }}
            >
                {/* pill box */}
                <a href="/pricing#compare"
                    className="plan-pill"
                    aria-label="Compare plans"
                >
                    <span className="plan-text">Compare All Our Plans Here</span>
                    <FiExternalLink className="plan-icon" />
                </a>
            </div>

            {/* styles */}
            <style>{`
        .plan-pill{
          margin-top: 1rem;
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:12px;
          text-decoration:none;
          background: #f8fbff;
          border-radius:18px;
          padding:28px 18px;
          border:1px solid rgba(0, 0, 0, 0);
          box-shadow:
            0 1px 0 rgba(255,255,255,.85) inset,
            0 6px 14px rgba(15,23,42,.08);
          color:#0f172a;
        }

         .plan-pill:hover{
          background:#e9f7ef;   
        }

        .plan-text{
          font-family: Inter;
          font-size:20px;
          font-weight:600;
          color: #242121ff;
          letter-spacing:.1px;
        }
        .plan-icon{
          font-size:18px;
          color: #0f172a;
          opacity:.9;
          flex-shrink:0;
        }
      `}</style>
        </section>
    );
};

export default Our_Plan;
